const { projects } = require("../../../config.json");
export default function Projects() {
    return (
        <div className="overflow-hidden ">
            <div className="container mx-auto px-4">
                <h1 className="text-3xl font-bold" data-aos="fade-right">Projelerimiz</h1>
                <hr className="mt-2 mb-4" />
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">

                    {projects.slice(0, 4).map((project, index) => (
                        <ProjectCard
                            key={index}
                            name={project.name}
                            banner={project.banner}
                            description={project.description}
                            link={project.link}
                            type={project.type}
                        />
                    ))}

                </div>
            </div>
        </div>
    )
}

function ProjectCard({ name, banner, description, link, type }) {
    return (
        <a href={link} target="_blank" data-aos="fade-up">
            <div className=" bg-[#eaeaea]/50 p-4 rounded-lg shadow-lg cursor-pointer hover:translate-y-2 hover:scale-[1.03] transition-all duration-300">
                <div className="flex items-center space-x-3 p-3">
                    <img src={banner} alt={name} className="w-12 h-12 rounded-full object-contain" />
                    <div>
                        <h1 className="text-lg font-bold">{name}</h1>
                        <p className="text-sm text-gray-500">{type}</p>
                    </div>
                </div>
                <p className="text-sm text-gray-600">
                    {description}
                </p>
            </div>
        </a>
    )
}